export default __webpack_public_path__ + "static/media/hero_bg@2x.6eb9abde.png";